import { render } from "./SaveTranslations.vue?vue&type=template&id=385dd56d&scoped=true"
import script from "./SaveTranslations.vue?vue&type=script&lang=js"
export * from "./SaveTranslations.vue?vue&type=script&lang=js"

import "./SaveTranslations.vue?vue&type=style&index=0&id=385dd56d&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\craft-cms-3-plugins\\craft3-translate\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385dd56d"]])

export default __exports__